// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"139":"80f91dbf","478":"db2cf2b0","749":"527e3137"}[chunkId] + ".css";
};